<div>
    <h2 style="margin: 5px 0 10px 0;">Duplicate Consumer</h2>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
        <div class="container">
            <div>
                <mat-form-field>
                    <input
                        matInput
                        required
                        placeholder="Consumer Name"
                        formControlName="name"
                    >
                    <mat-error *ngIf="form.controls['name'].invalid">Please enter a Name</mat-error>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <input
                        formControlName="tag"
                        matInput
                        pattern="^[A-Z_0-9]*$"
                        placeholder="Consumer Tag"
                        required
                        (focusout)="findTagExists()"
                    >
                    <mat-error *ngIf="form.controls['tag'].invalid && !form.controls['tag'].value">
                        Please enter a Standard Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.pattern && form.controls['tag'].value">
                        Please enter a Valid Standard Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.tagExists && form.controls['tag'].touched">
                        Tag already exists! Create a new one.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div  style="margin-top: 30px;" class="flex-center-center">
            <button
                class="button-color"
                mat-raised-button
                matTooltip="Cancel Creating Consumer"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
            >Cancel</button>
            <button
                class="button-color"
                [disabled]="form.invalid"
                mat-raised-button
                matTooltip="Submit Consumer"
                type="submit"
            >Save</button>
        </div>
    </form>
</div>
